import { IPayload } from './interface';

export const eventNameFromPayload = ({ context, subcontext, action }: IPayload): string =>
  [context, subcontext, action].filter((key) => !!key).join(' - ');
